import { useMutation, useQueryClient } from 'react-query';

import { memberRemindersApi } from 'src/Services/API';
import { CreateMemberReminderDto } from 'src/Services/API/generated';

interface UseCreateReminderOptions {
  onSuccess?: () => void;
}

export const useCreateReminder = (options?: UseCreateReminderOptions) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ assetId, data }: { assetId: string; data: CreateMemberReminderDto }) =>
      memberRemindersApi.memberRemindersControllerCreate(assetId, data),
    {
      onSuccess: (_, { assetId, data }) => {
        queryClient.invalidateQueries(['fetch-asset-reminders', assetId]);
        queryClient.invalidateQueries(['fetch-member-reminders', assetId, data.targetMemberId]);
        options?.onSuccess?.();
      },
    }
  );
};
